import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home/home.component';
import { HttpClientModule } from '@angular/common/http';
import { FlexLayoutModule } from '@angular/flex-layout';
import { HelpComponent } from './help/help.component';
import { RolesComponent } from './roles/roles.component';
import { PagemappingComponent } from './pagemapping/pagemapping.component';
import { LogoutComponent } from './logout/logout.component';
import { MaterialModule } from '../material/material.module';
import { TableComponent } from './table/table.component';
import { DataPropertyGetterPipe } from './table/data-property-getter-pipe/data-property-getter.pipe';

import { MyDocsComponent } from './upload/my-docs/my-docs.component';
import { ImpersonateUserComponent } from './impersonate-user/impersonate-user.component';
import { ErrorComponent } from './error/error.component';

import { ChartsModule } from 'ng2-charts';
import { PdfViewerModule } from 'ng2-pdf-viewer';

import * as CanvasJSAngularChart from '../../assets/charts/canvasjs.angular.component';
import { FieldErrorDisplayComponent } from '../field-error-display/field-error-display.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { MessageCenterComponent } from './message-center/message-center.component';
var CanvasJSChart = CanvasJSAngularChart.CanvasJSChart;

@NgModule({
  declarations: [HomeComponent,
    HelpComponent, RolesComponent, PagemappingComponent, LogoutComponent, TableComponent,
    DataPropertyGetterPipe,
    MyDocsComponent,
    ImpersonateUserComponent,
    ErrorComponent,
    CanvasJSChart,
    FieldErrorDisplayComponent,
    UnauthorizedComponent,
    MessageCenterComponent],
  imports: [
    HomeRoutingModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    ChartsModule,
    PdfViewerModule
  ],
  providers: [
    HttpClientModule],
  exports: [
    HomeComponent, HelpComponent, TableComponent,FieldErrorDisplayComponent
  ]
})
export class HomeModule {
}
